// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"a999311b","538":"b804a175","577":"cccf86a8","604":"bb9b4d5e","668":"a90d568f","673":"ad6a7480","831":"f0fab059","936":"fdc19ab0"}[chunkId] + ".chunk.js";
};